import router from '@user-plugins/routes/index.js'
import axiosInstanceUser from '@user-plugins/axios/index.js'

export default {
    namespaced: true,
    state: {
        authenticated: false,
        access_token: '',
        form: {
            username: '',
            password: '',
            remember: false
        },
        user: {},
        processing: false,
        error: {
            status: false,
            message: null
        },
        errors: {},
        resetpassword: {
            email: ''
        },
        curent_changepassword: {
            password: '',
            new_password: '',
            confirm_password: ''
        },
        changepassword: {
            email: '',
            token: '',
            new_password: '',
            confirm_the_new_password: ''
        }
    },
    mutations: {
        set_authenticated(state, value) {
            state.authenticated = value
        },
        set_user(state, user) {
            state.user = user
        },
        set_access_token(state, value) {
            state.access_token = value
        },
        set_logout(state) {
            state.authenticated = false
            state.user = {}
            state.access_token = ''
            router.push({name: 'login'}).then(() => {
            })
        },
        set_error(state, error) {
            state.error = error
        },
        set_errors(state, errors) {
            state.errors = errors
        },
    },
    actions: {
        async login({state, commit}) {
            state.processing = true
            await axiosInstanceUser.post('/login', state.form).then(({data}) => {
                commit('set_authenticated', true)
                commit('set_user', data.user)
                commit('set_access_token', data.access_token)
                router.push({name: 'payslips'})
            }).catch(({response}) => {
                commit('set_error', {status: true, message: response.data.message})
            }).finally(() => {
                state.processing = false
            })
        },

        async send_link_reset({state, commit}) {
            state.processing = true
            await axiosInstanceUser.post('/forgot-password', state.resetpassword).then(({data}) => {
                console.log(data)
            }).catch(({response}) => {
                commit('set_error', {status: true, message: response.data.message})
            }).finally(() => {
                state.processing = false
            })
        },

        async change_password({state, commit}) {
            state.processing = true
            await axiosInstanceUser.post('/change-password', state.changepassword).then(({data}) => {
                router.push({name: 'login'})
            }).catch(({response}) => {
                commit('set_error', {status: true, message: response.data.message})
            }).finally(() => {
                state.processing = false
            })
        },

        async curent_change_password({state, commit}) {
            state.processing = true
            await axiosInstanceUser.post('/curent/change-password', state.curent_changepassword).then(({data}) => {
                commit('set_user', data.user)
                router.push({name: 'payslips'})
            }).catch(({response}) => {
                //this.errors = response.data.errors;
                commit('set_errors', response.data.errors)
            }).finally(() => {
                state.processing = false
            })
        },

        async logout({state, commit}) {
            await axiosInstanceUser.post('/logout', state.user, {
                headers: {
                    Authorization: state.access_token,
                }
            }).then(() => {
                commit('set_authenticated', false)
                commit('set_user', {})
                commit('set_access_token', null)
                router.push({name: 'login'}).then(() => {
                })
            }).catch(() => {
            }).finally(() => {})

        }
    }
}
